module.exports = __webpack_public_path__ + "img/hero.815e8575.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero.jpg
// module id = VTGo
// module chunks = 0